import { ApiServiceMain } from 'boot/api'
import { jwtDecode } from 'jwt-decode'
import { CONFIG, BASE_URL } from 'src/common/config'
import { consoleLogAPI } from 'src/common/utils/errors'
import { getConfig } from 'src/configs'

const config = getConfig()
const OWN_SPORT = process.env.OWN_SPORT

export function actionToken(token) {
  try {
    const decoded = jwtDecode(token)

    const exp = decoded.exp * 1000
    const refreshTime = 60 * 60 * 24 * 1000
    const dateNow = Date.now()

    if (dateNow > exp) {
      return 'remove'
    } else if (dateNow > exp - refreshTime) {
      return 'refresh'
    }
    return 'none'
  } catch {
    return 'remove'
  }
}

export function configurationCookiesConfig(token, options) {
  try {
    const decoded = jwtDecode(token)
    const exp = decoded.exp

    return { ...options, expires: new Date(exp * 1000) }
  } catch {
    return { ...options }
  }
}

export function getAxiosOptionsURL() {
  let baseURL = `${location.origin}${BASE_URL}${process.env.VUE_APP_API_URL}`

  return {
    baseURL,
    timeout: CONFIG.API.TIMEOUT,
    headers: {
      Vary: 'Accept-Encoding',
    },
  }
}

export function getGqlURL(isGoBackend = false) {
  if (isGoBackend) {
    return `${location.origin}${BASE_URL}${process.env.GRAPHQL_GO_URI}`
  }
  return `${location.origin}${BASE_URL}${process.env.GRAPHQL_URI}`
}

export const setUssidToCookies = (ussid, expire) => {
  if (!config.authBySession) {
    return
  }
  return ApiServiceMain.auth
    .setSession({
      ussid,
      ussidt: Date.now().toString(),
      expire,
    })
    .catch(consoleLogAPI)
}

export const removeUssIdFromCookies = () => {
  if (!config.authBySession || OWN_SPORT) {
    return
  }
  return ApiServiceMain.auth.removeSession().catch(consoleLogAPI)
}
